import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

import { TooltipEmployeeProps } from '.';
import { getCssByXAlign } from './helper';

interface TooltipWrapperProps
  extends Pick<TooltipEmployeeProps, '$x' | '$y' | '$opacity' | 'xAlign'> {}

export const Wrapper = styled.div.attrs<TooltipWrapperProps>(({ $x, $y, $opacity }) => ({
  style: {
    left: `${$x}px`,
    top: `${$y}px`,
    opacity: $opacity,
  },
}))<TooltipWrapperProps>`
  position: absolute;
  min-width: 150px;
  background: ${({ theme }) => theme.colors.magenta700};
  padding: 10px;
  border-radius: 4px;
  pointer-events: none;
  transition: left 0.1s ease, top 0.1s ease, opacity 0.1s ease;

  &::before {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate3d(0, -50%, 0);
  }

  ${({ xAlign }) => getCssByXAlign(xAlign)};
`;

export const Date = styled.div`
  margin-bottom: 5px;
  color: ${({ theme }) => theme.colors.white100};
  ${getFontStyle('bold120_C2')};
`;

export const Revenue = styled.div`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.white100};
  ${getFontStyle('bold120_B3')};
`;

export const Income = styled.div`
  color: ${({ theme }) => theme.colors.white100};
  ${getFontStyle('bold120_C1')};
`;
